export default {"src":"/_next/static/media/setting.5b859fa2.svg","height":58,"width":57,"blurWidth":0,"blurHeight":0};